import { cva } from 'class-variance-authority';

export const container = cva(
  [
    'border-r',
    'bg-white',
    'border-neutral-200',
    'py-4',
    'px-4',
    'shadow-2xl',
    'flex',
    'flex-col',
    'w-full',
    'fixed',
    'top-0',
    'z-[48]',
    'md:py-8',
    'md:relative',
    'overflow-y-auto',
    'overflow-x-hidden',
    'md:overflow-y-visible',
    'md:overflow-x-visible',
    'group',
  ],
  {
    variants: {
      containerBottom: {
        'bottom-0': '!bottom-0',
        'bottom-auto': '!bottom-auto',
      },
    },
  },
);

export const content = cva([
  'hs-collapse md:flex',
  'flex-col mt-8 h-full justify-between',
]);

export const header = cva([
  'flex',
  'w-full',
  'justify-between',
  'md:justify-center',
  'items-center',
  'gap-4',
]);

export const logo = cva([
  'max-h-[24px]',
  'md:max-h-[42px]',
  'max-w-[224px]',
  'mr-auto',
]);

export const collapseButton = cva([
  'hidden',
  'md:group-hover:block',
  'group-data-[collapsed=true]:block',
  'bg-brand-50',
  'border',
  'border-brand-100',
  'w-fit',
  'p-1',
  'rounded-full',
  'shadow-md',
  'absolute',
  '-right-3',
  'hover:bg-brand-100',
]);

export const menu = cva([
  'hs-accordion-group',
  'overflow-y-auto',
  'flex',
  'flex-col',
  'gap-2',
  'md:h-full',
  'flex-grow',
]);
